import { LD_JSON_SCRIPT_TYPE } from '@/components/blocks/MetadataScript/constants';
import { MetadataScriptProps } from '@/components/blocks/MetadataScript/type';
import { getHomepageMetaData } from '@/components/blocks/MetadataScript/utils';
import Script from 'next/script';
import { FC } from 'react';
import { PAGES_METADATA } from 'shared/custom/constants/commonConstants';

export const MetadataScript: FC<MetadataScriptProps> = ({ type = LD_JSON_SCRIPT_TYPE, page }) => {
	const getMetadataScriptData = () => {
		switch (page) {
			case PAGES_METADATA.HOMEPAGE:
				return getHomepageMetaData();
			default:
				return null;
		}
	};

	return getMetadataScriptData()?.map((script, index) => (
		<Script
			id={`__metadata_script_${page}_${index}`}
			strategy="beforeInteractive"
			key={page + index}
			type={type}
			dangerouslySetInnerHTML={{
				__html: JSON.stringify(script),
			}}
		/>
	));
};
